import { NotContainsLowercaseError } from '../../validation/errors/not-contains-lowercase-error'
import { type FieldValidation } from '../../validation/protocols/field-validation'

export class ContainsLowercaseValidation implements FieldValidation {
  readonly field: string

  constructor (field: string) {
    this.field = field
  }

  validate (value: string): Error | null {
    if (value.length === 0) return null
    if (!value.match(/[a-z]/g)) return new NotContainsLowercaseError()
    return null
  }
}
